import { ITimeoutService } from 'angular';
import { IStateService } from 'angular-ui-router';
import { IStateGoOpts } from '../../../../ng2/shared/services/prev-state/prev-state.service';
import { ISchool } from '../../../../ng2/shared/typings/interfaces/school.interface';
import { IUser } from '../../../../ng2/shared/typings/interfaces/user.interface';
import { SpinnerModal } from './../../../shared/modals/status-spinner/status-spinner.service';

export class CreateSupportCtrl {
  public supportId: string;

  constructor(
    private $state: IStateService,
    private $timeout: ITimeoutService,
    private SpinnerModal: SpinnerModal,
    private currentSchool: ISchool,
    private currentSupport,
    private currentSupports,
    private currentUser: IUser,
    private goBackStateOpts: IStateGoOpts,
    private resolvedSchoolUsers,
    private studentIds: string[], // `studentIds` is used in stepper ctrl (CM)
  ) {
    this.supportId = $state.params.supportId;
    this.currentSupport.schoolId = this.currentSchool._id;

    // wait for a digest cycle before disabling spinner
    // otherwise, spinner is not disabled when coming from an sdc view (CM)
    $timeout(() => this.SpinnerModal.deactivateSpinner());
  }
}
